import React, { Component } from "react";
import { ReactComponent as Logo } from '../../assets/bgLogo.svg'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index'
import './header.css'
import EmailForm from '../EmailForm/emailForm.js'

class MobileHeader extends Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  render() {
    const { headerData, location } = this.props
    return (
      <div className={"mobile-header " + headerData.class}>
        <Navbar navItems={headerData.navBar} toggle={() => this.setState({ open: !this.state.open })} open={this.state.open} />
        {location === "/" && headerData && headerData.pageHeadData && <PageHeader location={location} pageHeadData={headerData.pageHeadData["/"]} />}
      </div>
    )
  }
}

const PageHeader = ({ pageHeadData }) => {
  return (
    <div className="mobile-page-header">
      {pageHeadData.data.title ? <h1 className="mobile-page-header-text">{pageHeadData.data.title.text}</h1> : null}
      {pageHeadData.data.emailForm && <EmailForm inputInfo={pageHeadData.data.emailForm} />}
    </div>
  )
}

const Navbar = ({ navItems, open, toggle }) => {
  return (
    <div className="mobile-navbar">
      <div className={"mobile-header-logo"}>
        <Link to="/">
          <Logo fill={"#ebebef"} alt={"Dark Logo"} />
        </Link>
      </div>
      <div onClick={toggle} className={"mobile-header-dropdown"}>
        <FontAwesomeIcon icon={open ? "times" : "bars"} />
      </div>
      <div className={"mobile-header-overlay " + (open ? "open" : "")} onClick={toggle}></div>
      <div className={"mobile-header-items " + (open ? "open" : "")}>
        <div onClick={toggle} className={"mobile-header-item"}>
          <FontAwesomeIcon className={"close-icon"} icon="times" />
        </div>
        {navItems.map(item =>
          <div className={"mobile-header-item"} key={item.name + "-> " + item.path} >
            {item.external ? <a target="_blank" rel="noopener noreferrer" className={"MankSans-Medium white-text"} href={item.path}>{item.name}</a> : <Link className={"MankSans-Medium white-text"} to={item.path}>{item.name}</Link>}
          </div>
        )}
      </div>

    </div>
  )
}

export default MobileHeader